import React, { useState } from "react";

import Effective from "./Effective";
import { InspectorContextProvider } from "contexts/Inspector";

const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "Effective",
    props: null
  });

  return (
    <InspectorContextProvider>
      <SwitchComponents active={pageProps.active}>
        <Effective
          name="Effective"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <></>
      </SwitchComponents>
    </InspectorContextProvider>
  );
};

export default Index;
